import type BaseRepository from "./BaseRepository";

export type ReceiptTypeUnion = "receipt-text" | "receipt-full" | "a4" | "email";

export type ReceiptServerTypeUnion = "NORMAL" | "TEXT_ONLY" | "A4" | "EMAIL";

export const ReceiptServerToLocalMap: Record<ReceiptServerTypeUnion, ReceiptTypeUnion> = {
    NORMAL   : "receipt-full",
    TEXT_ONLY: "receipt-text",
    A4       : "a4",
    EMAIL    : "email",
};

export const ReceiptLocalToServerMap: Record<ReceiptTypeUnion, ReceiptServerTypeUnion> = {
    "receipt-full": "NORMAL",
    "receipt-text": "TEXT_ONLY",
    "a4"          : "A4",
    "email"       : "EMAIL",
};

export interface ReceiptPaddingType {
    top: number | null;
    left: number | null;
    right: number | null;
    bottom: number | null;
}

export interface LocalDatabaseReceipt {
    accountReceipt: boolean;
    components: string; // TODO: Convert to proper type
    name: string;
    receiptWidth: number;
    type: ReceiptTypeUnion;
    uuid: string;
    padding: null | ReceiptPaddingType;
    attachments: null | Array<{
        receipt: string;
        name: string;
    }>;
}

export interface BaseReceiptRepository extends BaseRepository<LocalDatabaseReceipt> {
    filter(filter: (item: LocalDatabaseReceipt) => boolean): Promise<Array<LocalDatabaseReceipt>>;
    getByType(type: ReceiptTypeUnion): Promise<Array<LocalDatabaseReceipt>>;
}
